import { render } from "./UIInlineTab.vue?vue&type=template&id=6d1d8476&scoped=true"
import script from "./UIInlineTab.vue?vue&type=script&lang=js"
export * from "./UIInlineTab.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-6d1d8476"

export default script